import { inject, Injectable } from '@angular/core';
import { applyTheme, argbFromHex, themeFromSourceColor } from '@material/material-color-utilities';
import { DOCUMENT } from '@angular/common';
import { ThemeColorSet } from '@aipb/gulliver/env/model';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  #document = inject(DOCUMENT);

  generateToolbarTheme(theme?: ThemeColorSet) {
    if (!theme || !theme.background || !theme.foreground) return;

    const targetElement = this.#document.documentElement;
    targetElement.style.setProperty('--toolbar-background', theme.background);
    targetElement.style.setProperty('--toolbar-foreground', theme.foreground);
  }

  generateSidebarHeaderTheme(theme?: ThemeColorSet) {
    if (!theme || !theme.background || !theme.foreground) return;

    const targetElement = this.#document.documentElement;
    targetElement.style.setProperty('--sidebar-header-background', theme.background);
    targetElement.style.setProperty('--sidebar-header-foreground', theme.foreground);
  }

  generateDynamicTheme(color: string) {
    const fallbackColor = '#005cbb';
    const sourceColor = color;

    let argb;
    try {
      argb = argbFromHex(sourceColor);
    } catch (error) {
      // falling to default color if it's invalid color
      argb = argbFromHex(fallbackColor);
    }

    const targetElement = this.#document.documentElement;

    // Get the theme from a hex color
    const theme = themeFromSourceColor(argb);

    // Identify if user prefers dark theme
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    // Apply theme to root element
    applyTheme(theme, {
      target: targetElement,
      dark: false,
      brightnessSuffix: true
    });

    const styles = targetElement.style;

    for (const key in styles) {
      if (Object.prototype.hasOwnProperty.call(styles, key)) {
        const propName = styles[key];
        if (propName.indexOf('--md-sys') === 0) {
          const sysPropName = '--sys' + propName.replace('--md-sys-color', '');
          targetElement.style.setProperty(sysPropName, targetElement.style.getPropertyValue(propName));
        }
      }
    }
  }
}
